'use strict';

angular.module('app.common')

.directive('upComingAuctions', [ '$document', '$timeout', function($document, $timeout) {
	function link() {
		$timeout(function() {
			angular.element($document).foundation('reflow');
		}, 0);
	}

	return {
		restrict: 'E',
		scope: true,
		templateUrl: 'app/common/directives/upcomingauctions/upComingAuctions.html',
		link: link
	}
} ]);



// WEBPACK FOOTER //
// ./app/common/directives/upcomingauctions/upComingAuctionsDirective.js